import "./HeroBanner.scss";
// import { Link } from "react-router-dom";
import profile from "../../assets/images/Profile.jpeg";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useEffect, useState } from "react";

export default function HeroBanner() {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoader(false), 500);
  }, []);

  return (
    <section className="hero">
      <Container className={!loader ? "" : "container--hidden"}>
        <Row xs={1} sm={2}>
          <Col className="hero__description-wrapper">
            <p className="hero__subtitle">Hi! I'm</p>
            <h2 className="hero__title">Gabriela Terasaka,</h2>
            <p className="hero__subtitle">
              a Full-Stack Web Developer based in Canada.
            </p>
            <p className="hero__description">
              From my previous work experience as an Analyst, I discovered my
              passion for logical thinking and problem-solving. My goal is to
              always put my best effort into improving efficiency and providing
              the best solution for each project.
            </p>
            <a href="/#projects" className="hero__button">
              My Projects
            </a>
          </Col>
          <Col>
            <div className="hero__image-box">
              <div className="hero__image-line">
                <img className="hero__image" src={profile} alt="profile" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
